class ProductCardSwatches extends HTMLElement {
  connectedCallback() {
    const buttons = this.querySelectorAll('.swatch-button');
    
    buttons.forEach(button => {
      button.addEventListener('click', this.handleSwatchClick.bind(this));
    });
  }

  handleSwatchClick(event) {
    event.preventDefault();
    event.stopPropagation();
    
    const button = event.currentTarget;
    if (button.disabled) return;

    const variantImage = button.dataset.variantImage;
    if (!variantImage) return;

    const productCard = this.closest('product-card');
    if (!productCard) return;

    const mediaGallery = productCard.querySelector('product-card-media-gallery');
    if (!mediaGallery) return;

    const slider = mediaGallery.querySelector('slider-component');
    if (slider) {
      const firstSlide = slider.querySelector('.splide__slide');
      if (firstSlide) {
        const firstImage = firstSlide.querySelector('img');
        if (firstImage) {
          const image200 = variantImage.replace('width=1200', 'width=200');
          const image400 = variantImage.replace('width=1200', 'width=400');
          const image600 = variantImage.replace('width=1200', 'width=600');
          
          firstImage.src = variantImage;
          firstImage.srcset = `${image200} 200w, ${image400} 400w, ${image600} 600w, ${variantImage} 1200w`;
        }
      }
    } else {
      const firstImage = mediaGallery.querySelector('img');
      if (firstImage) {
        const image200 = variantImage.replace('width=1200', 'width=200');
        const image400 = variantImage.replace('width=1200', 'width=400');
        const image600 = variantImage.replace('width=1200', 'width=600');
        
        firstImage.src = variantImage;
        firstImage.srcset = `${image200} 200w, ${image400} 400w, ${image600} 600w, ${variantImage} 1200w`;
      }
    }

    const allButtons = this.querySelectorAll('.swatch-button');
    allButtons.forEach(btn => {
      btn.removeAttribute('aria-checked');
    });
    button.setAttribute('aria-checked', 'true');
  }
}

if (!customElements.get('product-card-swatches')) {
  customElements.define('product-card-swatches', ProductCardSwatches);
}

